const GLTListEmptyTile = () => {
  return (
    <div className="item-tile empty-tile">
      <span>No Templates available.</span>
    </div>
  );
};

export default GLTListEmptyTile;
